import { type Maybe } from '@vrplatform/utils';
import type { party_enum } from '@vrplatform/graphql';
import { useState } from 'react';

type Type = 'adjustment' | 'financial';

type ReclassifyLine = {
  reservationId: string;
  sourceLineId: string;
  sourceLineType: string;
  sourceDescription: string;
  sourceCentTotal: number;
};

export function useReservationFinancialsModals() {
  const [opened, setOpened] = useState<{
    id?: string;
    reservationId: string;
    lineType: string;
    description: string;
    centTotal: number | undefined;
    postingAt: Maybe<string>;
    party: party_enum;
    type: Type;
  } | null>(null);

  const [deleteModalReservationLine, setDeleteModalReservationLine] = useState<{
    id: string;
    reservationId: string;
    type: Type;
  } | null>(null);

  const [reclassifyLine, setReclassifyLine] = useState<ReclassifyLine | null>(
    null
  );

  return {
    edit: {
      opened,
      setOpened,
    },
    remove: {
      opened: deleteModalReservationLine,
      setOpened: setDeleteModalReservationLine,
    },
    reclassify: {
      opened: reclassifyLine,
      setOpened: setReclassifyLine,
    },
  };
}
